import React from 'react';
import styled from 'styled-components';

const ColorBox = ({
  color,
  isSize = 'medium',
}: {
  color: string;
  isSize: 'small' | 'medium' | 'large';
}) => {
  const sizes = {
    small: '10px',
    medium: '15px',
    large: '20px',
  };
  const BoxDiv = styled.div`
    width: ${sizes[isSize]};
    height: ${sizes[isSize]};
    background: ${color};
    border: 2px solid black;
  `;
  return <BoxDiv aria-hidden={true} />;
};

export default ColorBox;

//
